var map = {
	"./1.png": 8241,
	"./10.png": 7269,
	"./11.png": 4380,
	"./2.png": 3578,
	"./3.png": 5155,
	"./4.png": 4988,
	"./5.png": 7877,
	"./6.png": 5774,
	"./7.png": 3463,
	"./8.png": 9840,
	"./9.png": 1017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3858;